export default __webpack_public_path__ + "static/media/roadmap9.a7291504.png";